<mip-modal size="lg" maxWidth="500px" [fullHeight]="false" *ngIf="isOpened">
  <mip-card>
    <!-- HEADER -->
    <mip-card-header>
      <ng-content select="[modal-title]"></ng-content>
      <div *ngIf="title" [innerHTML]="title"></div>
    </mip-card-header>

    <!-- CONTENT -->
    <mip-card-content>
      <ng-content select="[modal-message]"></ng-content>
      <div *ngIf="message" [innerHTML]="message"></div>
    </mip-card-content>

    <!-- FOOTER -->
    <mip-card-footer>
      <button
        class="action action--cancel"
        mat-button
        *ngIf="disableCancelAction === false"
        [disabled]="busy"
        (click)="cancel()"
      >
        {{ cancelActionLabel | translate }}
      </button>

      <button
        class="action action--confirm"
        mat-button
        mipBgColor="black"
        *ngIf="disableConfirmAction === false"
        [disabled]="busy"
        (click)="confirm()"
      >
        <mip-loading *ngIf="busy" color="white" size="3x"></mip-loading>
        <span *ngIf="!busy">{{ confirmActionLabel | translate }}</span>
      </button>

      <ng-content select="[modal-actions]"></ng-content>
    </mip-card-footer>
  </mip-card>
</mip-modal>
